export default __webpack_public_path__ + "static/media/logo-14-corendon-hotels-resorts.85fbc938.png";